import { combineReducers } from 'redux';
import { AppState, appReducer } from 'src/reducers/appReducer';
import { authReducer, AuthState } from 'src/reducers/authReducer';
import { PlatformState, platformReducer } from 'src/reducers/platformReducer';

export default combineReducers({
  auth: authReducer,
  app: appReducer,
  platform: platformReducer,
});

export type IRootReducers = {
  auth: AuthState;
  app: AppState;
  platform: PlatformState;
};
